import { ENDPOINTS } from './api/endpoints';

export const validateFrontendApiKey = async (key: string) => {
  if (!key) {
    return Promise.resolve(false);
  }

  const apiResponse = await window.fetch(ENDPOINTS.authenticate, {
    method: 'POST',
    headers: { X_FRONTEND_API_KEY: key }
  });

  const apiStatus = apiResponse.status;
  return apiStatus === 204;
};
